import { render, staticRenderFns } from "./vueRecurrentPayments.vue?vue&type=template&id=5715435b&scoped=true"
import script from "./vueRecurrentPayments.vue?vue&type=script&lang=js"
export * from "./vueRecurrentPayments.vue?vue&type=script&lang=js"
import style0 from "./vueRecurrentPayments.vue?vue&type=style&index=0&id=5715435b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5715435b",
  null
  
)

export default component.exports